import { render } from "./Papers.vue?vue&type=template&id=2f942c75&scoped=true"
import script from "./Papers.vue?vue&type=script&lang=js"
export * from "./Papers.vue?vue&type=script&lang=js"

import "./Papers.vue?vue&type=style&index=0&id=2f942c75&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f942c75"]])

export default __exports__